import React, { Component } from 'react';
import {Badge} from 'react-bootstrap';
import PanelView from '../model/PanelView.js';
import {clone} from '../util/Utility.js';
import {CCOButton} from '../util/Components';
import moment from 'moment';

export default class BugPanelView extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      object: null,
    };

    this.state = {
      object: clone(props.objectPass),
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      this.state = clone(this.defaultState);
      this.setState({object: clone(newProps.objectPass)});
    }
  }

  render() {

    var object = this.state.object;

    return (
      <PanelView type="bugs" setState={this.setState.bind(this)} object={object} {...this.props}>
        <div style={{textAlign: 'left'}}>
          <h4>{object.name || "Anonymous"} <Badge color="purple">{object.type}</Badge> <Badge>{object.os}</Badge> <Badge>Native {object.version}</Badge> <Badge>Codepush {object.codepush}</Badge></h4>
          {object.date !== undefined && <p style={{color: 'gray', fontSize: 10, marginTop: -5}}>Sent on {moment.unix(object.date).format("dddd, MMMM Do YYYY [at] h:mm:ss A")}</p>}
          <div style={{height: 7}} />
          <p>{object.message}</p>
          <div style={{height: 10}} />
          <center>
            <CCOButton type="primary" width={200} text="Email User" onClick={() => window.location.href = "mailto:" + object.email} />
            <p style={{fontSize: 10, color: 'gray'}}>{object.email}</p>
          </center>
        </div>
      </PanelView>
    );

  }
}



/** WEBPACK FOOTER **
 ** ./src/bugs/BugPanelView.js
 **/